<template>
<div id="enter-name-text"> 
    <single-line-text-editor ref="singleLineText" :text="nameInternal" :optional="optional" textAreaId="rv-entryName" 
                textInputWrapperClass="inputContainer" :createTextWithSize="false"
                :config="textCanvasConfig" label="Geben Sie den Namen des Kindes ein:"
                @change="updateName" @changeInternal="updateInternalName"></single-line-text-editor>
</div>
</template>

<script type="ts">
import { Module, VuexModule, getModule } from 'vuex-module-decorators'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { TreasureBookModule } from '@/store/modules/treasureBook'
import SingleLineTextEditor from '@/components/common/SingleLineTextEditor.vue'
import { TextCanvasConfig } from '@/components/common/TextCanvas.vue'

export default {
    name: 'enter-name-text',
    props: {
        optional: Boolean
    },
    data: function() {
        return {
            nameOriginal: "",
            userInputNameOriginal: "",
            valid: false,
        }
    },
    created: function() {
        this.nameOriginal = TreasureBookModule.name
        this.userInputNameOriginal = TreasureBookModule.userInputName
    },
    computed: {
        nameInternal: function() {
            return TreasureBookModule.userInputName
        },
        textCanvasConfig: function() {
            return AppModule.textConfig
        }
    },
    watch: {
        valid: function(newValid) {
            this.$emit('confirmableChanged', newValid)
        }
    },
    methods: {
        cancel: function() {
            TreasureBookModule.SetName(this.nameOriginal)
            TreasureBookModule.SetUserInputName(this.userInputNameOriginal)
        },
        updateName: function(newValue) {
            TreasureBookModule.SetName(newValue)
            this.valid = this.$refs.singleLineText.validate()
        },
        updateInternalName: function(newValue) {
            TreasureBookModule.SetUserInputName(newValue)
            this.valid = this.$refs.singleLineText.validate()
        },
    },
    mounted: function() {
        this.valid = this.$refs.singleLineText.validate()
    },
    components: {
        SingleLineTextEditor
    }
}
</script>


<style lang="scss">
#enter-name{
    
    .inputContainer{
        height: 387px;

         @media (max-width: $rv-doubleTeaserBreakpoint) {
            height:initial;
        }
        input:focus{
            outline: none;
            border-color:#80bdff;
            box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.25);

        }
    }
}
</style>